export { default as LocationTiles } from './LocationTiles';
